module.exports = __webpack_public_path__ + "static/img/ayeheychris.7a745ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/conversion/testimonial/ayeheychris.png
// module id = SPlO
// module chunks = 35